const passwordChangeValidator = props => {
    // Destructured props
    const {formValues} = props;

    // Actual form field validator for the first step
    const validateForm = props => {
        // Destructured props
        const {
            target,
            value
        } = props;

        let errors = {};

        // Validates each individual field
        switch (target) {
            case "newPassword":
                if (!value) {
                    errors.newPassword = "Esse campo é obrigatório.";
                } else if (value && value.length < 8) {
                    errors.newPassword = "Sua senha deve possuir no mínimo 8 caracteres.";
                } else {
                    errors.newPassword = "";
                }

                break;
            case "confirmNewPassword":
                if (!value) {
                    errors.confirmNewPassword = "Esse campo é obrigatório.";
                } else if (value && value.length < 8) {
                    errors.confirmNewPassword = "Sua senha deve possuir no mínimo 8 caracteres.";
                } else if (value && value !== formValues.newPassword) {
                    errors.confirmNewPassword = "Suas senhas devem ser iguais.";
                } else {
                    errors.confirmNewPassword = "";
                }

                break;
            default:
                return errors;
        }

        return errors;
    }

    // Method to perform a validation in all fields at once
    const validateAll = () => {
        let errors = {};

        // Iterates through each field validating them
        Object.keys(formValues).forEach(key => {
            const args = {
                target: key,
                value: formValues[key]
            }

            errors = {
                ...errors,
                ...validateForm(args)
            }
        })

        // Returns the errors object to be set into the errors state
        return errors;
    }

    return {
        validateForm,
        validateAll
    }
}

export default passwordChangeValidator;
